export default __webpack_public_path__ + "assets/texas-logo-white-transp.png";